document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('cart-popup');
    const closeBtn = document.getElementById('close-popup');
    let popupDisplayed = false;
    let popupDismissed = false;

    const productHandles = ['gratis-pose-godbidder', 'gratis-pose-katte-snacks', 'gratis-gnaver-snacks', 'gratis-fugle-snacks'];
    const minimumCartValue = 300;
    const firstItemPriceLimit = 300;

    // Gave-badge og shippingbar elementer
    const giftBadge = document.getElementById('gift-badge');
    const remainingAmountElement = document.getElementById('remaining-amount');
    const giftThreshold = 300;

    let firstProductId = null;
    let isBadgeOpen = false;
    let firstTimeShown = true;

    // Overvåg DOM for ændringer for at fange, hvornår shippingbar bliver tilføjet
    const observer = new MutationObserver(function(mutationsList, observer) {
        mutationsList.forEach(mutation => {
            if (mutation.addedNodes.length > 0) {
                const shippingBar = document.querySelector('#shippingbar');
                if (shippingBar) {
                    console.log('Shippingbar element found:', shippingBar);
                    observer.disconnect(); // Stop observer, når shippingbar er fundet
                    monitorCartChanges(); // Start overvågning af kurvændringer
                }
            }
        });
    });

    // Start observeren på body-elementet for at fange alle ændringer i DOM'en
    observer.observe(document.body, { childList: true, subtree: true });

    // Åbn popupen
    function openPopup() {
        if (!popupDismissed) {
            popup.style.display = 'block';
            popupDisplayed = true;
        }
    }

    // Luk popupen
    function closePopup() {
        popup.style.display = 'none';
        popupDisplayed = false;
        popupDismissed = true;
    }

    // Lyt efter klik på "Luk"-knappen
    closeBtn.addEventListener('click', closePopup);

    // Hent det aktuelle antal varer i kurven og dens samlede pris
    function fetchCartDetails() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                if (firstProductId !== null && !cart.items.some(item => item.id === firstProductId)) {
                    firstProductId = null;
                }
                if (firstProductId === null && cart.items.length > 0) {
                    firstProductId = cart.items[cart.items.length - 1].id;
                }
                return {
                    cartItems: cart.items,
                    totalPrice: cart.total_price / 100,
                    hasTriggerProducts: cart.items.some(item => productHandles.includes(item.handle)), // Tjekker for trigger-produkter
                    firstItemSingleUnitPrice: getFirstProductPrice(cart.items),
                    itemCount: cart.item_count
                };
            })
            .catch(error => {
                console.error('Error fetching cart details:', error);
                return { cartItems: [], totalPrice: 0, hasTriggerProducts: false, firstItemSingleUnitPrice: 0, itemCount: 0 };
            });
    }

    // Hjælpefunktion til at finde prisen på 1x af det første tilføjede produkt
    function getFirstProductPrice(cartItems) {
        const firstProduct = cartItems.find(item => item.id === firstProductId);
        return firstProduct ? firstProduct.price / 100 : 0;
    }

    // Opdater gave-badge, shippingbar og popup
    function updateElements(totalPrice, itemCount, hasTriggerProducts) {
        const remainingAmount = giftThreshold - totalPrice;
        const shippingBar = document.querySelector('#shippingbar');

        // Badge og shippingbar vises/fjernes
        if (itemCount > 0 && remainingAmount > 0) {
            giftBadge.style.display = 'block';
            if (shippingBar) {
                shippingBar.style.display = 'block'; // Vis shippingbar
            }
            remainingAmountElement.textContent = remainingAmount;

            // Automatisk udvid badget første gang det vises
            if (firstTimeShown) {
                firstTimeShown = false;
                giftBadge.classList.add('expanded');

                setTimeout(() => {
                    giftBadge.classList.remove('expanded');
                }, 3000);
            }
        } else {
            giftBadge.style.display = 'none';
            if (shippingBar) {
                shippingBar.style.display = 'none'; // Skjul shippingbar
            }
        }

        // Popup logik - Åbn popup hvis betingelserne er opfyldt, og trigger-produkterne ikke er i kurven
        if (!popupDisplayed && totalPrice >= minimumCartValue && !hasTriggerProducts) {
            openPopup();
        }

        // Luk popup hvis et af trigger produkterne er i kurven
        if (popupDisplayed && hasTriggerProducts) {
            closePopup();
        }
    }

    // Tjek kurven for ændringer
    function monitorCartChanges() {
        fetchCartDetails().then(cart => {
            if (cart.totalPrice < minimumCartValue) {
                cart.cartItems.forEach((item, index) => {
                    if (productHandles.includes(item.handle)) {
                        removeProductFromCart(index + 1);  // Brug line-item index til at fjerne produktet
                    }
                });
            }

            // Tjek om prisen på én enhed af det første tilføjede produkt er over 300 kr
            if (cart.firstItemSingleUnitPrice > firstItemPriceLimit) {
                console.log('Første produkt i kurven (1x enhed) er over 300 kr. Popup vises ikke.');
                return;
            }

            // Opdater gave-badge, shippingbar og popup
            updateElements(cart.totalPrice, cart.itemCount, cart.hasTriggerProducts);
        });
    }

    // Fjern et produkt fra kurven baseret på line-item index
    function removeProductFromCart(lineItemIndex) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                line: lineItemIndex,
                quantity: 0 // Sætter mængden til 0 for at fjerne varen
            }),
        }).then(response => response.json())
          .then(data => {
              console.log('Product removed:', data);
              popupDisplayed = false;
              popupDismissed = false;
              monitorCartChanges();
          })
          .catch(error => console.error('Error removing product:', error));
    }

    // Start overvågning af kurvændringer
    setInterval(monitorCartChanges, 2000);
});
